import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./i18n";

// Fix React 19 removeChild error caused by third-party scripts (Google Translate, extensions)
// that manipulate the DOM outside React's control
const container = document.getElementById("root");
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <App />
  );
}
